import { createSelector } from 'reselect';

export const selectAccessVouchersSlice = state => state.accessVouchers;

export const selectAccessVouchers = createSelector(
  selectAccessVouchersSlice,
  slice => slice.accessVouchers
);
export const accessVouchersLoaded = createSelector(
  selectAccessVouchersSlice,
  slice => slice.accessVouchersLoaded
);
export const selectActiveAccessVoucher = createSelector(
  selectAccessVouchersSlice,
  slice => slice.activeAccessVoucher
);

export const accessVouchersMeta = createSelector(
  selectAccessVouchersSlice,
  slice => slice.meta
);
export const accessVouchersFilters = createSelector(
  selectAccessVouchersSlice,
  slice => slice.filters
);

export const accessVouchersCreating = createSelector(
  selectAccessVouchersSlice,
  slice => slice.isCreating
);
export const accessVouchersUpdating = createSelector(
  selectAccessVouchersSlice,
  slice => slice.isUpdating
);
export const accessVouchersDeleting = createSelector(
  selectAccessVouchersSlice,
  slice => slice.isDeleting
);
export const accessVouchersErrors = createSelector(
  selectAccessVouchersSlice,
  slice => slice.errors
);
